(function () {
  'use strict';

  /* @ngdoc object
   * @name mealDetail
   * @description
   *
   */
  angular
    .module('mealDetail', [
      'ui.router'
    ]);
}());
